module.exports = __webpack_public_path__ + "img/Kizing-curved-baby-and-toddler-spoon-supports-self-feeding.52d72dc8.jpeg";